import React from 'react'
import { Routes, Route } from 'react-router-dom'
import LandingPage from './pages/LandingPage'
import StylePage from './pages/StylePage'

function App() {
    return (
        <div className="min-h-screen bg-gray-50">
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/style/:styleId" element={<StylePage />} />
            </Routes>
        </div>
    )
}

export default App
